import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, Grid } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import locale from 'date-fns/locale/en-US';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import {
  Button, Input, Select, Label,
} from '@ipc/ipc-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { postDenestImpcMappingAddRequestActionCreator } from '../../redux/actions/DenestImpcMappingActions';
import { getImpcsWithMrdsList } from '../../../../../common/impc/redux/selectors/ImpcSelectors';
import { tableLoadData } from '../../../../../common/list-table/actions/ListTableActions';
import { StyledModalForm } from '../../../../../common/list-table/helpers/formModal.styles';

function DenestImpcMappingAddDialog(props) {
  const [mrdImpc, setMrdImpc] = useState();
  const [denestImpc, setDenestImpc] = useState();
  const [operator, setOperator] = useState('');
  const [selectedValidFrom, setSelectedValidFrom] = useState(moment().add(1, 'days'));
  const [selectedValidTo, setSelectedValidTo] = useState();
  const [validDate, setValidDate] = useState(true);
  const [validToValidDate, setValidToValidDate] = useState(true);
  const [isMappingOverlapped, setIsMappingOverlapped] = useState();
  const {
    closeDialog,
    openDialog,
    addRequest,
    mrdImpcOptions,
    currentMapping,
  } = props;

  const impcOptions = [];
  mrdImpcOptions.map((index) => impcOptions.push({ label: index.impc, value: index.impc }));

  const ischeckMappingOverlap = (mrd, denest, fromDate, toDate) => {
    let isOverlapped = false;
    const filteredArray = currentMapping.filter((row) => (row.mrdImpc === mrd) && (row.denestImpc === denest));
    filteredArray.map((index) => {
      if (!isOverlapped) {
        if (index.validTo === null && toDate === undefined) {
          isOverlapped = true;
        } else if (index.validTo !== null && toDate === undefined) {
          if (!moment(new Date(fromDate).setHours(0, 0, 0, 0)).isAfter(moment(index.validTo))) {
            isOverlapped = true;
          }
        } else if (index.validTo === null && toDate !== undefined) {
          if (!(moment(new Date(toDate).setHours(0, 0, 0, 0)).isBefore(moment(index.validFrom))
            && moment(new Date(fromDate).setHours(0, 0, 0, 0)).isBefore(moment(index.validFrom)))) {
            isOverlapped = true;
          }
        } else if (index.validTo !== null && toDate !== undefined) {
          if (!((moment(new Date(fromDate).setHours(0, 0, 0, 0)).isBefore(moment(index.validFrom))
            && moment(new Date(toDate).setHours(0, 0, 0, 0)).isBefore(moment(index.validFrom)))
            || (moment(new Date(fromDate).setHours(0, 0, 0, 0)).isAfter(moment(index.validTo))
            && moment(new Date(toDate).setHours(0, 0, 0, 0)).isAfter(moment(index.validTo))))) {
            isOverlapped = true;
          }
        }
      }
      return isOverlapped;
    });
    return isOverlapped;
  };
  useEffect(() => {
    if (selectedValidFrom.isValid() && selectedValidFrom.isValid()) {
      const valid = ischeckMappingOverlap(mrdImpc, denestImpc, selectedValidFrom, selectedValidTo);
      setIsMappingOverlapped(valid);
    }
  }, [mrdImpc, denestImpc, selectedValidFrom, selectedValidTo]);

  const handleNewMrdImpc = (selectedOption) => {
    let mrdOperator = '';
    setMrdImpc(selectedOption.value);
    mrdImpcOptions.find((index) => {
      if (index.impc === selectedOption.value) {
        mrdOperator = index.operator;
      }
      return mrdOperator;
    });
    setOperator(mrdOperator);
    const valid = ischeckMappingOverlap(selectedOption.value, denestImpc, selectedValidFrom, selectedValidTo);
    setIsMappingOverlapped(valid);
  };

  const handleDenestImpc = (e) => {
    const impcValue = e.target.value;
    setDenestImpc(impcValue.toUpperCase());
    const valid = ischeckMappingOverlap(mrdImpc, impcValue.toUpperCase(), selectedValidFrom, selectedValidTo);
    setIsMappingOverlapped(valid);
  };

  const onValidToChange = (date) => {
    setSelectedValidTo(date !== null ? moment(date) : undefined);
    const valid = ischeckMappingOverlap(mrdImpc, denestImpc, selectedValidFrom, date !== null ? date : undefined);
    setIsMappingOverlapped(valid);
  };
  const onValidFromChange = (date) => {
    setSelectedValidFrom(moment(date));
    if (date !== null && date.toString() !== 'Invalid Date') {
      const valid = ischeckMappingOverlap(mrdImpc, denestImpc, date, selectedValidTo);
      setIsMappingOverlapped(valid);
    }
  };

  const onInvalidDate = (message) => {
    setValidDate(message === '');
  };

  const onInvalidValidToDate = (message) => {
    setValidToValidDate(message === '');
  };

  async function confirmSave() {
    await addRequest(denestImpc, mrdImpc, operator, selectedValidFrom, selectedValidTo);
    closeDialog();
  }

  const isFormValid = () => !(mrdImpc === undefined
    || selectedValidFrom === null
    || selectedValidFrom === undefined
    || selectedValidFrom.toString() === 'Invalid Date'
    || (validDate === false)
    || (validToValidDate === false)
    || (selectedValidTo !== undefined && selectedValidTo.toString() === 'Invalid Date')
    || denestImpc === undefined
    || denestImpc.length !== 6
    || isMappingOverlapped !== false
    || (selectedValidTo !== undefined && moment(selectedValidFrom).isAfter(moment(selectedValidTo))));

  return (
    <Dialog onClose={closeDialog} aria-labelledby="simple-dialog-title" open={openDialog}>
      <StyledModalForm>
        <DialogTitle id="simple-dialog-title">New MRD IMPC - Denest IMPC mapping</DialogTitle>
        <div>
          <table className="form-details">
            <tbody>
              <tr>
                <td className="form-input-fields">
                  <Label>MRD IMPC*</Label>
                </td>
                <td className="form-input-fields">
                  <Select
                    value={mrdImpc}
                    placeholder={mrdImpc}
                    options={impcOptions}
                    onChange={handleNewMrdImpc}
                    maxMenuHeight={225}
                  />
                </td>
              </tr>
              <tr>
                <td className="form-input-fields">
                  <Label>Denest IMPC*</Label>
                </td>
                <td className="form-input-fields">
                  <Input
                    type="text"
                    value={denestImpc}
                    minLength={6}
                    maxLength={6}
                    onChange={(e) => handleDenestImpc(e)}
                    style={{ textTransform: 'uppercase' }}
                  />
                </td>
              </tr>
              <tr>
                <td className="form-input-fields">
                  <Label>Operator*</Label>
                </td>
                <td className="form-input-fields">
                  <Label>{operator}</Label>
                </td>
              </tr>
              <tr>
                <td className="form-input-fields">
                  <Label>Valid from*</Label>
                </td>
                <td className="form-input-fields">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container>
                      <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        format="dd-MM-yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        value={selectedValidFrom}
                        onChange={(e) => onValidFromChange(e)}
                        onError={onInvalidDate}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="form-input-fields">
                  <Label>Valid to</Label>
                </td>
                <td className="form-input-fields">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container>
                      <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        format="dd-MM-yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        minDate={selectedValidFrom}
                        value={selectedValidTo !== undefined ? selectedValidTo : null}
                        onChange={(e) => onValidToChange(e)}
                        onError={onInvalidValidToDate}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
            </tbody>
          </table>
          {denestImpc && (denestImpc.length === 6) && (isMappingOverlapped === true) && (
            <div className="validation-message">
              <span>
                There is an active mapping for the
                &nbsp;
                {denestImpc}
                &nbsp;
                with overlapping validity.
              </span>
            </div>
          )}
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={closeDialog}>Cancel</Button>
          <Button
            onClick={confirmSave}
            className={`primary-button-${!isFormValid()} action`}
            disabled={!isFormValid()}
          >
            Save
          </Button>
        </div>
      </StyledModalForm>
    </Dialog>
  );
}

DenestImpcMappingAddDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.bool,
  addRequest: PropTypes.func,
  mrdImpcOptions: PropTypes.arrayOf(PropTypes.object),
  currentMapping: PropTypes.arrayOf(PropTypes.object),
};

function mapStateToProps(state) {
  return {
    mrdImpcOptions: getImpcsWithMrdsList(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  addRequest: postDenestImpcMappingAddRequestActionCreator,
  tableLoad: tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DenestImpcMappingAddDialog);
